import { configureStore } from "@reduxjs/toolkit";
import { enableMapSet } from "immer";
import cartSlice from "./slices/cartSlice";
import userSlice, { initLocalStorageSync } from "./slices/userSlice";
import userDataSlice from "./slices/UserStateSlice";
import settingSlice from "./slices/settingSlice";
import imageSlice from "./slices/ImageSlice";
import GiftSlice from "./slices/GiftSlice";
import FreeServiceSlice from "./slices/FreeServiceSlice";
import RequestFormSlice from "./slices/RequestFormSlice";
import ServiceInfoSlice from "./slices/ServiceInfoSlice";
import PaymentSlice from "./slices/PaymentSlice";
import localCommunityAdsSlice from "./slices/LcaSlice";
import MyNeedsSlice from "./slices/MyNeedsSlice";
import MessagesSlice from "./slices/MsgSlice";
import IteamFormSlice from "./slices/IteamFormSlice";
import peopleInCom from "./slices/PeopleInComSlice";
import gurdwaraSlice from "./slices/GurdwaraSlice";
import TemplateSlice from "./slices/TemplateSlice";
import donationReducer from "./slices/DonationSlice";
import latestStates from "./slices/LatestAdsSlice";
import ItemsDataSlice from "./slices/ItemsDataSlice";
import socketSlice from "./slices/SocketSlice";
import userSates from "./slices/UserStateSlice";
import comWebSlice from "./slices/ComWebSlice";
import PostFormSlice from "./slices/PostFormSlice";
import SearchBarSlice from "./slices/SearchBarSlice";
import ReportsSlice from "./slices/ReportsSlice";
import HomeSlice from "./slices/HomeSlice";
import BwvSlice from "./slices/bwvSlice";
import LcaAndBwvSlice from "./slices/LcaAndBwvSlice";
import MediaSlice from "./slices/MediaSlice";
import categoryActions from "./slices/CategorySlice";
import PostsSlice from "./slices/reviewposts";
import OrderSlice from "./slices/OrderSlice";
import CustomFieldsSlice from "./slices/CustomFieldsSlice";
// import commentLikeSlice from "./slices/likesComments";
import conversationReducer from "./slices/inboxSlice";

enableMapSet();
// add middlewares to the store
const store = configureStore({
  reducer: {
    cart: cartSlice,
    user: userSlice,
    setting: settingSlice,
    image: imageSlice,
    gift: GiftSlice,
    freeService: FreeServiceSlice,
    requestForm: RequestFormSlice,
    serviceInfo: ServiceInfoSlice,
    payment: PaymentSlice,
    bwvData: BwvSlice,
    lcAds: localCommunityAdsSlice,
    myNeeds: MyNeedsSlice,
    messages: MessagesSlice,
    IteamForm: IteamFormSlice,
    peopleInCom: peopleInCom,
    gurdwara: gurdwaraSlice,
    templates: TemplateSlice,
    gurdwaraDonation: donationReducer,
    latestState: latestStates,
    ItemsData: ItemsDataSlice,
    socket: socketSlice,
    userState: userSates,
    website: comWebSlice,
    postForm: PostFormSlice,
    searchBar: SearchBarSlice,
    reports: ReportsSlice,
    homeData: HomeSlice,
    lcaAndVendors: LcaAndBwvSlice,
    media: MediaSlice,
    userSettingsCount: userDataSlice,
    categories: categoryActions,
    posts: PostsSlice,
    orders: OrderSlice,
    customFields: CustomFieldsSlice,
    // commentLike: commentLikeSlice,
    conversation: conversationReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().filter(
      (middleware) => middleware !== getDefaultMiddleware().serializableCheck
    ),
});
initLocalStorageSync(store);
export default store;
